import apiCall from '@/utils/api';

export const DEFAULT_YEAR_VALUE = 'All';
export const DEFAULT_YEAR_LABEL = 'All (Year 2021-2023)';

export const fetchUoas = async (containerId: string, typeId: string) => {
    const {data} = await apiCall({
        url: `containers/${containerId}/uoa`,
        params: {
            type_id: typeId,
            pagination: false,
        },
    });

    return data.items.map((item: {id: number; title: string}) => ({
        id: item.id,
        name: item.title,
    }));
};

export const fetchCheckpoints = async (containerId: string) => {
    const {data} = await apiCall({
        url: `containers/${containerId}/checkpoints`,
        params: {
            container_id: containerId,
        },
    });

    const values = data.checkpoints.map((item: {id: number; name: string}) => ({
        id: item.id,
        name: item.name,
    }));

    values.unshift({
        id: DEFAULT_YEAR_VALUE,
        name: DEFAULT_YEAR_LABEL,
    });

    return values;
};
